import axios from 'axios';
import store from '../store';
import { deleteUserData } from '../store/actions';
import { deleteConfigData } from '../store/actions3';
import { deleteConfigDataSystem } from '../store/actions4';
import { convertCamelToSnake } from './camelToSnakeUtil';

// create an axios instance
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  // baseURL: serverAddres.value,
  timeout: 1*60*1000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  async (config) => {
    // const SignCode = getStorage("SignCode");
    // config.headers['Sign-Code'] = SignCode
    const token = localStorage.getItem('ycToken'); // 或从 Cookie 中读取
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config
  },
  error => {

    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  async (response) => {
    // ✅ 如果是 Blob 数据，直接返回完整响应（包含 headers 和 data）
    if (response.config.responseType === 'blob') {
        return response; // 确保 response.data 是 Blob
    }
    //token过期
    if(response.data.code&&response.data.code==401){

      store.dispatch(deleteUserData());
      store.dispatch(deleteConfigDataSystem())
      store.dispatch(deleteConfigData())
      return Promise.reject("token过期")
    }
    
    // 检查是否需要驼峰转下划线处理
    if (response.config.convertCamelToSnake === true) {
      const processedData = convertCamelToSnake(response.data);
      return processedData;
    }
    
    return response.data
  },
    error => {
      if (!error.response) { // 如果什么都没有`response` 那就是网络异常 直接抛出一个错误
        return Promise.reject(error)
      }

      if (error.response.status === 401) { // 如果不等于401 那么不做操作，直接将错误抛出
        const res = error.response.data
        // console.log(res)
        // if (res.code === 1011) {
        //   //请求要求身份验证 跳转到登录页
        //   store.dispatch(deleteUserData());
        // }

        return Promise.reject(res)
      } else {
        return Promise.reject(error.response.data)
      }
    }
)

export default service
